import {
    getPlaceCategories,
    GetPlaceCategoriesApiResponseSchema,
} from './get-place-categories';
import {
    getPlacesByCategory,
    GetPlacesByCategoryUidApiResponseSchema,
} from './get-places-by-category';

export {
    GetPlacesByCategoryUidApiResponseSchema,
    GetPlaceCategoriesApiResponseSchema,
};

export const PlacesPageActions = {
    getPlacesByCategory,
    getPlaceCategories,
};
